/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Sort_RelevanceInputs */

const en_us2_plan_build_sort_relevance = /** @type {(inputs: Plan_Build_Sort_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevance`)
};

const pt_br2_plan_build_sort_relevance = /** @type {(inputs: Plan_Build_Sort_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevância`)
};

const es_419_plan_build_sort_relevance = /** @type {(inputs: Plan_Build_Sort_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevancia`)
};

const pt_pt2_plan_build_sort_relevance = /** @type {(inputs: Plan_Build_Sort_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevância`)
};

const fr_fr2_plan_build_sort_relevance = /** @type {(inputs: Plan_Build_Sort_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertinence`)
};

const de_de2_plan_build_sort_relevance = /** @type {(inputs: Plan_Build_Sort_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevanz`)
};

const it_it2_plan_build_sort_relevance = /** @type {(inputs: Plan_Build_Sort_RelevanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevanza`)
};

/**
* | output |
* | --- |
* | "Relevance" |
*
* @param {Plan_Build_Sort_RelevanceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_sort_relevance = /** @type {((inputs?: Plan_Build_Sort_RelevanceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Sort_RelevanceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_sort_relevance(inputs)
	if (locale === "es-419") return es_419_plan_build_sort_relevance(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_sort_relevance(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_sort_relevance(inputs)
	if (locale === "de-DE") return de_de2_plan_build_sort_relevance(inputs)
	if (locale === "it-IT") return it_it2_plan_build_sort_relevance(inputs)
	return en_us2_plan_build_sort_relevance(inputs)
});
export { plan_build_sort_relevance as "plan-build.sort_relevance" }